module.exports = __webpack_public_path__ + "img/dsci0036.ccd0d9c6.jpg";